// Module
var code = `<div class="activar"
    id="activar">

    <div class="container container--space">

        <div class="activar__intro">
            <h3 class="activar__title"
                ng-bind-html="\$ctrl.activarData.title"></h3>
            <div class="activar__description"
                ng-bind-html="\$ctrl.activarData.description">
            </div>
        </div>

        <!-- tabs -->
        <div class="global-tabs">
            <button type="button"
                class="global-tab link-global link-global--lg"
                ng-repeat="tab in \$ctrl.activarData.tabs"
                ng-click="\$ctrl.selectTab(tab)"
                ng-class="{ 'global-tab--active': \$ctrl.activeTab.id === tab.id }">
                {{ tab.label }}
            </button>
        </div>

        <!-- tab content -->
        <div class="global-content js-activar-content"
            ng-if="\$ctrl.activeTab">

            <div class="row  d-lg-flex justify-content-lg-center">
                <div ng-repeat="step in \$ctrl.activeTab.steps track by step.id"
                    class="col-12 col-lg-3">
                    <div class="activar__box-step"
                        ng-style="{
                            'background-image': 'url(' + \$ctrl.getBackground(step) + ')'
                            }">
                        <div class="activar__overlay"></div>
                        <div class="activar__step-text"
                            ng-bind-html="step.text"></div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>`;
// Exports
export default code;